// extracted by mini-css-extract-plugin
export default {"root":"api-usage-analytics_root__X3SWZ","body":"api-usage-analytics_body__2YVAu"};